import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Icon from 'assets/icons/';

import styles from './AccessScreenHeader.module.scss';

interface AccessScreenHeader {
  title: string;
}
export const AccessScreenHeader = ({ title }: AccessScreenHeader) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.header}>
      {/* eslint-disable  */}
      <a className={styles.backButton} onClick={() => history.push('/dsa')}>
        <Icon.ArrowShortLeft className={styles.icon} />
      </a>
      {/* eslint-enable */}
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>
          {t('accessScreenHeader.subtitle')}
        </div>
      </div>
    </div>
  );
};
